import { render, staticRenderFns } from "./Rating2Star.vue?vue&type=template&id=7af34c32"
import script from "./Rating2Star.vue?vue&type=script&lang=js"
export * from "./Rating2Star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7af34c32')) {
      api.createRecord('7af34c32', component.options)
    } else {
      api.reload('7af34c32', component.options)
    }
    module.hot.accept("./Rating2Star.vue?vue&type=template&id=7af34c32", function () {
      api.rerender('7af34c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Rating2Star.vue"
export default component.exports